import {
  eventLocations,
  eventProperties,
  events,
} from 'client/GrowthEngineering/utilities/GrowthConstants';
import EventManager from 'client/GrowthEngineering/EventManager';
import SystemUserApi from 'client/api/v2/SystemUserApi';
import UserApi from 'client/api/v2/UserApi';

const {
  boolean,
  description,
  location,
  section,
  text,
} = eventProperties;

/**
 * "Add" button click events
 */
const triggerAddNewUserButtonClicked = (props = {}) => {
  EventManager.triggerEvent(events.addNewUserButtonClicked, props);
};

const triggerAddNewUserFromCSVButtonClicked = (props = {}) => {
  EventManager.triggerEvent(events.addNewUserFromCSVButtonClicked, props);
};

const triggerAddNewDeviceButtonClicked = (props = {}) => {
  EventManager.triggerEvent(events.addNewDeviceButtonClicked, props);
};

const triggerAddUserToUserGroupButtonClicked = (props = {}) => {
  EventManager.triggerEvent(events.addUserToUserGroupButtonClicked, props);
};

const triggerAddResourceDropDownItemClicked = (props = {}) => {
  EventManager.triggerEvent(events.addResourceDropDownItemClicked, props);
};

const triggerConnectUserToDeviceButtonClicked = (props = {}) => {
  EventManager.triggerEvent(events.connectUserToDeviceButtonClicked, props);
};

const triggerAddPolicyGroupFromTemplateClicked = (props = {}) => {
  EventManager.triggerEvent(events.iconClicked, props);
};

/**
 * Aside Events
 */
const triggerCopyWellClicked = (payload = {}) => {
  EventManager.triggerEvent(events.copyWellClicked, payload);
};

/**
 * System Insight Events
 */
const triggerSystemInsightsView = (payload = {}) => {
  EventManager.triggerEvent(events.systemInsightsView, payload);
};

/**
 * Administrator events
 */
const triggerAdminSaved = (props = {}) => {
  EventManager.triggerEvent(events.administratorSaved, props);
};

const triggerAdminStatusChange = (props = {}) => {
  EventManager.triggerEvent(events.adminStatusChange, props);
};

const triggerAddMTPAdminPageOpened = (payload = {}) => {
  EventManager.triggerEvent(events.addMTPAdminPageOpened, payload);
};

const triggerNewMTPAdminAdded = (payload = {}) => {
  EventManager.triggerEvent(events.newMTPAdminAdded, payload);
};

const triggerEditAdminInformation = (props = {}) => {
  EventManager.triggerEvent(events.editAdminInformation, props);
};

const triggerAdminResendEmail = () => {
  EventManager.triggerEvent(events.adminResendEmail);
};

const triggerAddNewAdminButtonClicked = (payload = {}) => {
  EventManager.triggerEvent(events.addNewAdminButtonClicked, payload);
};

const triggerCreateNewAdminModalCanceled = (payload = {}) => {
  EventManager.triggerEvent(events.createNewAdminModalCanceled, payload);
};

const triggerAdministratorsModalClosed = (payload = {}) => {
  EventManager.triggerEvent(events.administratorsModalClosed, payload);
};

const triggerAdminDropdownButtonClicked = (payload = {}) => {
  EventManager.triggerEvent(events.adminDropdownButtonClicked, payload);
};

/**
 * Attribute driven groups events
 */

const triggerMembershipSuggestionsButtonClicked = (payload = {}) => {
  EventManager.triggerEvent(events.membershipSuggestionsButtonClicked, payload);
};

const triggerMembershipSuggestionsModalClosed = (payload = {}) => {
  EventManager.triggerEvent(events.membershipSuggestionsModalClosed, payload);
};

const triggerMembershipSuggestionsLinkClicked = (payload = {}) => {
  EventManager.triggerEvent(events.membershipSuggestionsLinkClicked, payload);
};

/**
 * Chat events
 */
const triggerChatPopoverDismissed = (payload = {}) => {
  EventManager.triggerEvent(events.chatPopoverDismissed, payload);
};

const triggerChatPopoverCtaClicked = (payload = {}) => {
  EventManager.triggerEvent(events.chatPopoverCtaClicked, payload);
};

/**
 * FAQ events
 */
const triggerFaqClicked = (payload = {}) => {
  EventManager.triggerEvent(events.faqClicked, payload);
};

/**
 * Login and Logout events
 */
const triggerLogOutClicked = (props = {}) => {
  EventManager.triggerEvent(events.logOutClicked, props);
};

/**
 * Enable/Disable User Portal System Install events
 */
const triggerUserPortalSystemAgentInstall = (payload = {}) => {
  EventManager.triggerEvent(events.userPortalSystemAgentInstall, payload);
};

/**
 * Header events
 */

const triggerPricingButtonClicked = (props = {}) => {
  EventManager.triggerEvent(events.pricingButtonClicked, props);
};

/**
 * Home Panel events
 */
const triggerHomePageLinkClicked = (props = {}) => {
  EventManager.triggerEvent(events.homePageLinkClicked, props);
};

const triggerHomePageManageHomeLinkClicked = (props = {}) => {
  EventManager.triggerEvent(events.homePageManageHomeLinkClicked, props);
};

const triggerHomePageManageToggleClicked = (props = {}) => {
  EventManager.triggerEvent(events.homePageManageToggleClicked, props);
};

/**
 * Home Widget events
 */
const triggerHomeWidgetActionButtonClicked = (props = {}) => {
  EventManager.triggerEvent(events.homeWidgetActionButtonClicked, props);
};

const triggerWidgetClicked = (props = {}) => {
  EventManager.triggerEvent(events.widgetClicked, props);
};

const triggerHomeWidgetHideClicked = (props = {}) => {
  EventManager.triggerEvent(events.homeWidgetHideClicked, props);
};

const triggerHomeWidgetIndividualItemClicked = (props = {}) => {
  EventManager.triggerEvent(events.homeWidgetIndividualItemClicked, props);
};

/**
 * Import events
 */
const triggerBulkImportUsersInitiated = (props = {}) => {
// props expected importType: csv, workday, and others
// usersToImport: number of users attempting to be imported
  EventManager.triggerEvent(events.bulkImportUsersInitiated, props);
};

const triggerImportUsersComplete = (props = {}) => {
// props expected importType: csv, workday, and others
// successfullyImported: number of successfully imported users
  EventManager.triggerEvent(events.importUsersComplete, props);
};

const triggerSubmitIdea = (payload = {}) => {
  EventManager.triggerEvent(events.submitIdea, payload);
};

const triggerAddUsersFromGSuiteButtonClicked = () => {
  EventManager.triggerEvent(events.addUsersFromGSuiteButtonClicked);
};

const triggerAddUsersFromO365ButtonClicked = () => {
  EventManager.triggerEvent(events.addUsersFromO365ButtonClicked);
};

const triggerEnterCreditCardButtonClicked = (payload = {}) => {
  EventManager.triggerEvent(events.enterCreditCardButtonClicked, payload);
};

/**
 * Insights panel events
 */
const triggerActivityLogColumnsChanged = (props = {}) => {
  EventManager.triggerEvent(events.activityLogColumnsChanged, props);
};

const triggerActivityLogExported = (props = {}) => {
  EventManager.triggerEvent(events.activityLogExported, props);
};

const triggerActivityLogDateRangeChanged = (props = {}) => {
  EventManager.triggerEvent(events.activityLogDateRangeChanged, props);
};

const triggerActivityLogFilterChanged = (props = {}) => {
  EventManager.triggerEvent(events.activityLogFilterChanged, props);
};

const triggerActivityLogFilterOptionsLoaded = (props = {}) => {
  EventManager.triggerEvent(events.activityLogFilterOptionsLoaded, props);
};

const triggerActivityLogFilterTemplateSelected = (props = {}) => {
  EventManager.triggerEvent(events.triggerActivityLogFilterTemplateSelected, props);
};

const triggerActivityLogTableCellValueClicked = (props = {}) => {
  EventManager.triggerEvent(events.activityLogTableCellValueClicked, props);
};

const triggerInsightsVideoPlayed = () => {
  EventManager.triggerEvent(events.insightsVideoPlayed);
};

const triggerInsightsPaywallViewed = (props = {}) => {
  EventManager.triggerEvent(events.insightsPaywallViewed, props);
};

const triggerInsightsPaywallEmailClicked = () => {
  EventManager.triggerEvent(events.insightsPaywallEmailClicked);
};

const triggerInsightsPaywallPricingClicked = () => {
  EventManager.triggerEvent(events.insightsPaywallPricingClicked);
};

/**
 * Item addition events
 */
const triggerApplicationAdded = (props = {}) => {
  if (props && props.isNewApplication) {
    EventManager.triggerEvent(events.applicationAdded, props);
    EventManager.triggerEvent(events.resourceAdded, {
      resourceType: 'application',
      ...props,
    });
  }
};

const triggerCommandAdded = (props = {}) => {
  EventManager.triggerEvent(events.commandAdded, props);
};

const triggerCommandTemplatesClicked = (props = {}) => {
  EventManager.triggerEvent(events.commandTemplateClicked, props);
};

const triggerPolicySaveAsTemplateClicked = (props = {}) => {
  EventManager.triggerEvent(events.buttonClicked, props);
};

const triggerSaveTemplateAsPolicyGroupClicked = (props = {}) => {
  EventManager.triggerEvent(events.buttonClicked, props);
};

const triggerRecommendedCommandClicked = (props = {}) => {
  EventManager.triggerEvent(events.recommendedCommandClicked, props);
};

const triggerDirectoryAdded = (props = {}) => {
  EventManager.triggerEvent(events.directoryAdded, props);
  EventManager.triggerEvent(events.resourceAdded, {
    resourceType: 'directory',
    ...props,
  });
};

const triggerDirectoryImportUsersLinkClicked = (props = {}) => {
  EventManager.triggerEvent(events.directoryImportUsersLinkClicked, props);
};

const triggerAddNewDirectoryTypeSelected = (payload = {}) => {
  EventManager.triggerEvent(events.addNewDirectoryTypeSelected, payload);
};

const triggerAuthorizeSyncClicked = (payload = {}) => {
  EventManager.triggerEvent(events.authorizeSyncClicked, payload);
};

const triggerDeactivateSyncClicked = (payload = {}) => {
  EventManager.triggerEvent(events.deactivateSyncClicked, payload);
};

const triggerDeactivateSyncConfirmed = (payload = {}) => {
  EventManager.triggerEvent(events.deactivateSyncConfirmed, payload);
};

const triggerReactivateSyncClicked = (payload = {}) => {
  EventManager.triggerEvent(events.reactivateSyncClicked, payload);
};

const triggerGroupAdded = (props = {}) => {
  EventManager.triggerEvent(events.groupAdded, props);
};

const triggerAddNewLdapButtonClicked = (payload = {}) => {
  EventManager.triggerEvent(events.addNewLdapButtonClicked, payload);
};

const triggerLdapAdded = (props = {}) => {
  EventManager.triggerEvent(events.ldapAdded, props);
};

const triggerPolicyAdded = (props = {}) => {
  if (props && props.isNewPolicy) {
    EventManager.triggerEvent(events.policyAdded, props);
  }
};

const triggerRadiusAdded = (props = {}) => {
  EventManager.triggerEvent(events.radiusAdded);
  EventManager.triggerEvent(events.resourceAdded, {
    resourceType: 'radius',
    resourceName: 'radius',
    ...props,
  });
};

const triggerResourceAdded = (props = {}) => {
  EventManager.triggerEvent(events.resourceAdded, props);
};

const triggerSoftwareAppAdded = (props = {}) => {
  EventManager.triggerEvent(events.managedSoftwareAdded, props);
};

const triggerSystemGroupAdded = (props = {}) => {
  EventManager.triggerEvent(events.systemGroupAdded, props);
};

const triggerUserAdded = (props = {}) => {
  EventManager.triggerEvent(events.userAdded, props);
};

const triggerUserGroupAdded = (props = {}) => {
  EventManager.triggerEvent(events.userGroupAdded, props);
};

/**
 * Item Table events
 */
const triggerItemTableExported = (props = {}) => {
  EventManager.triggerEvent(events.itemTableExported, props);
};

/**
 * Item Table events
 */
const triggerMdmButtonClicked = (props = {}) => {
  EventManager.triggerEvent(events.mdmButtonClicked, props);
};

/**
 * Legacy Router events
 */
const triggerLegacyPageRedirect = (payload = {}) => {
  EventManager.triggerEvent(events.legacyPageRedirect, payload);
};

const triggerLegacyRouterPathVisited = (props = {}) => {
  EventManager.triggerEvent(events.legacyRouterPathVisited, props);
};

/**
 * MDM events
 */
const triggerMdmChecklistItemClicked = (props = {}) => {
  EventManager.triggerEvent(events.mdmChecklistItemClicked, props);
};

const triggerMdmHomeVideoPlayed = (props = {}) => {
  EventManager.triggerEvent(events.mdmHomeVideoPlayed, props);
};

/**
 * Org Payment events
 */

const triggerPaymentInfoSubmitted = async () => {
  const totalCount = await SystemUserApi.fetchTotalCount();
  EventManager.triggerEvent(events.paymentInfoSubmitted, {
    numUsers: totalCount,
  });
};

/**
 * Provider Payment events
 */
const triggerProviderPaymentModalViewed = () => {
  UserApi.getSelf().then((resp) => {
    EventManager.triggerEvent(events.providerPaymentModalViewed, {
      providerId: resp.provider,
    });
  });
};

const triggerProviderPaymentModalDismissed = (props = {}) => {
  UserApi.getSelf().then((resp) => {
    EventManager.triggerEvent(events.providerPaymentModalDismissed, {
      providerId: resp.provider,
      ...props,
    });
  });
};

const triggerProviderPaymentInfoSubmitted = () => {
  UserApi.getSelf().then((resp) => {
    EventManager.triggerEvent(events.providerPaymentInfoSubmitted, {
      providerId: resp.provider,
    });
  });
};

const triggerProviderPaymentLinkClicked = async (props = {}) => {
  const resp = await UserApi.getSelf();
  return EventManager.triggerEvent(events.paymentLinkClicked, {
    providerId: resp.provider,
    ...props,
  });
};

const triggerProviderCalendlyLinkClicked = async (props = {}) => {
  const resp = await UserApi.getSelf();
  return EventManager.triggerEvent(events.calendlyLinkClicked, {
    providerId: resp.provider,
    ...props,
  });
};

const triggerProviderOutreachLinkClicked = async (props = {}) => {
  const resp = await UserApi.getSelf();
  return EventManager.triggerEvent(events.outreachLinkClicked, {
    providerId: resp.provider,
    ...props,
  });
};

const triggerPaymentLinkClicked = async (props = {}) => {
  const totalCount = await SystemUserApi.fetchTotalCount();
  return EventManager.triggerEvent(events.paymentLinkClicked, {
    numUsers: totalCount,
    ...props,
  });
};

const triggerPaymentChatLinkClicked = async (props = {}) => {
  const totalCount = await SystemUserApi.fetchTotalCount();
  return EventManager.triggerEvent(events.paymentChatClicked, {
    numUsers: totalCount,
    ...props,
  });
};

const triggerContactSalesButtonClicked = async (props = {}) => {
  const totalCount = await SystemUserApi.fetchTotalCount();
  return EventManager.triggerEvent(events.contactSalesButtonClicked, {
    numUsers: totalCount,
    ...props,
  });
};

const triggerEmailSalesLinkClicked = async (props = {}) => {
  const totalCount = await SystemUserApi.fetchTotalCount();
  return EventManager.triggerEvent(events.emailSalesLinkClicked, {
    numUsers: totalCount,
    ...props,
  });
};

const triggerCalendlyLinkClicked = async (props = {}) => {
  const totalCount = await SystemUserApi.fetchTotalCount();
  return EventManager.triggerEvent(events.calendlyLinkClicked, {
    numUsers: totalCount,
    ...props,
  });
};

const triggerOutReachLinkClicked = async (props = {}) => {
  const totalCount = await SystemUserApi.fetchTotalCount();
  return EventManager.triggerEvent(events.outreachLinkClicked, {
    numUsers: totalCount,
    ...props,
  });
};

/**
 * Resources events
 */

const triggerGettingStartedHowItWorksModalDismissed = (props = {}) => {
  EventManager.triggerEvent(events.gettingStartedHowItWorksModalDismissed, props);
};

const triggerGettingStartedHowItWorksModalViewed = (props = {}) => {
  EventManager.triggerEvent(events.gettingStartedHowItWorksModalViewed, props);
};

const triggerGroupsGettingStartedModalDismissed = () => {
  EventManager.triggerEvent(events.groupsGettingStartedModalDismissed);
};

const triggerGroupsGettingStartedModalViewed = () => {
  EventManager.triggerEvent(events.groupsGettingStartedModalViewed);
};

const triggerWhatsNewOpened = () => {
  EventManager.triggerEvent(events.resourcesPanelOpened);
};

const triggerWhatsNewClosed = (payload = {}) => {
  EventManager.triggerEvent(events.resourcesPanelClosed, payload);
};

const triggerResourcesWhatsNewReadMoreLinkClicked = (payload = {}) => {
  EventManager.triggerEvent(events.resourcesWhatsNewReadMoreLinkClicked, payload);
};

/**
 * Reports page events
 */
const triggerReportExported = (payload = {}) => {
  EventManager.triggerEvent(events.reportExported, payload);
};

const triggerReportTypeVisited = (payload = {}) => {
  EventManager.triggerEvent(events.reportTypeVisited, payload);
};

/**
 * System events
 */
const triggerSystemAcknowledged = (payload = {}) => {
  EventManager.triggerEvent(events.systemAcknowledged, payload);
};

const triggerSystemBound = (payload = {}) => {
  EventManager.triggerEvent(events.systemBound, payload);
};

const triggerSystemCompatibilityLearnMoreClicked = (payload = {}) => {
  EventManager.triggerEvent(events.compatibilityNotesLearnMoreClicked, payload);
};

const triggerSystemsDownloadAgentButtonClicked = (payload = {}) => {
  EventManager.triggerEvent(events.systemsDownloadAgentButtonClicked, {
    osType: payload.os,
  });
};

const triggerSystemGetAgentLogClicked = (payload = {}) => {
  EventManager.triggerEvent(events.systemGetAgentLogClicked, payload);
};

const triggerSystemDownloadAgentLogClicked = (payload = {}) => {
  EventManager.triggerEvent(events.systemDownloadAgentLogClicked, payload);
};

/**
 * Trigger System Support events
 */
const triggerSystemSupportLinkClicked = (payload = {}) => {
  EventManager.triggerEvent(events.systemSupportLinkClicked, payload);
};

/**
 * Trigger System Tab events
 */
const triggerSystemTabClicked = (payload = {}) => {
  EventManager.triggerEvent(events.systemTabClicked, { osType: payload.osType });
};

/**
 * Navigation events
 */
const triggerNavItemClicked = (payload = {}) => {
  EventManager.triggerEvent(events.navItemClicked, payload);
};

const triggerNavMenuItemClicked = (payload = {}) => {
  EventManager.triggerEvent(events.navMenuItemClicked, payload);
};

const triggerNavPanelCollapsed = (payload = {}) => {
  EventManager.triggerEvent(events.navPanelCollapsed, payload);
};

/**
 * RADIUS events
 */

const triggerRadiusGettingStartedLearnMoreClicked = (payload = {}) => {
  EventManager.triggerEvent(events.radiusGettingStartedLearnMoreClicked, payload);
};

const triggerRadiusGettingStartedNewServerSaved = (payload = {}) => {
  EventManager.triggerEvent(events.newRadiusSaveServerClicked, payload);
};

/**
 * Banner
 */
const triggerBannerLinkClicked = (payload = {}) => {
  EventManager.triggerEvent(events.bannerLinkClicked, payload);
};

const triggerApplicationBannerCheckItOutButtonClicked = (payload = {}) => {
  EventManager.triggerEvent(events.applicationBannerCheckItOutButtonClicked, payload);
};

const triggerApplicationBannerLearnMoreButtonClicked = (payload = {}) => {
  EventManager.triggerEvent(events.applicationBannerLearnMoreButtonClicked, payload);
};

/**
 * Trigger Signup events
 */

const triggerSignupQuestionAnswered = (payload = {}) => {
  EventManager.triggerEvent(events.signupQuestionAnswered, payload);
};

const triggerSignupQuestionConfirmationModalClicked = (payload = {}) => {
  EventManager.triggerEvent(events.signupQuestionConfirmationModalClicked, payload);
};

/**
 * Collapsable Section (GetStartedInstructions)
 */
const triggerCollapsableSectionLinkClicked = (payload = {}) => {
  EventManager.triggerEvent(events.collapsableSectionLinkClicked, {
    ...payload,
  });
};

const triggerCollapsableSectionButtonClicked = (payload = {}) => {
  EventManager.triggerEvent(events.collapsableSectionButtonClicked, {
    ...payload,
  });
};

const triggerCollapsableSectionControlEvent = (payload = {}) => {
  EventManager.triggerEvent(events.collapsableSectionControlEvent, {
    ...payload,
  });
};

/**
 * ModalFooter events
 */
const triggerModalFooterKbLinkClicked = (payload = {}) => {
  EventManager.triggerEvent(events.modalFooterKbLinkClicked, {
    ...payload,
  });
};

/**
 * Ways To Add System User events
 */
const triggerWaysToAddSystemUserLearnMoreClicked = (payload = {}) => {
  EventManager.triggerEvent(events.waysToAddSystemUserLearnMoreClicked, {
    ...payload,
  });
};

/**
 * Ways To Add Device events
 */
const triggerWaysToAddDeviceLearnMoreClicked = (payload = {}) => {
  EventManager.triggerEvent(events.waysToAddDeviceLearnMoreClicked, {
    ...payload,
  });
};

/**
 * Video Modal events
 */
const triggerVideoModalLinkClicked = (payload = {}) => {
  EventManager.triggerEvent(events.videoModalLinkClicked, {
    ...payload,
  });
};

/**
 * Welcome modal events
 */
const triggerWelcomeModalDismissed = (payload = {}) => {
  EventManager.triggerEvent(events.welcomeModalDismissed, payload);
};

const triggerWelcomeModalVideoPlayed = (payload = {}) => {
  EventManager.triggerEvent(events.welcomeModalVideoPlayed, {
    ...payload,
  });
};

/**
 * Product tour events
 */
const triggerProgressDotsClicked = (payload = {}) => {
  EventManager.triggerEvent(events.progressDotsClicked, payload);
};

const triggerProductTourLaunchButtonClicked = (payload = {}) => {
  EventManager.triggerEvent(events.productTourLaunchButtonClicked, payload);
};

/**
 * User Detail events
 */
const triggerLocalUserAccountModalClicked = (payload = {}) => {
  EventManager.triggerEvent(events.localUserAccountModalClicked, payload);
};

/**
 * Devices new requirements Policies
 */
const triggerDeviceMacPolicies = (payload = {}) => {
  EventManager.triggerEvent(events.deviceMacPolicies, payload);
};

/**
 * Mobile Signup Notification events
 */
const triggerNotOptimizedForMobileModalViewed = (payload = {}) => {
  EventManager.triggerEvent(events.notOptimizedForMobileModalViewed, payload);
};

const triggerContinueWithMobileLinkClicked = (payload = {}) => {
  EventManager.triggerEvent(events.continueWithMobileLinkClicked, payload);
};

const triggerGettingStartedLdapProtipLearnMoreClicked = (props = {}) => {
  EventManager.triggerEvent(events.gettingStartedLdapProtipLearnMoreClicked, props);
};

// Generic Events
const triggerAsideViewed = (payload = {}) => {
  EventManager.triggerEvent(events.asideViewed, payload);
};

const triggerButtonClicked = (payload = {}) => {
  EventManager.triggerEvent(events.buttonClicked, payload);
};

const triggerCheckboxClicked = (payload = {}) => {
  EventManager.triggerEvent(events.checkboxClicked, payload);
};

const triggerImplementationChecklistComplete = (feature, eventText) => {
  triggerCheckboxClicked({
    [boolean]: true,
    [description]: 'The implementation checklist was completed.',
    [location]: eventLocations.implementationChecklistSidebar,
    [section]: `${feature} Card`,
    [text]: eventText,
  });
};

const triggerImplementationChecklistFeatureComplete = (feature, eventText) => {
  triggerCheckboxClicked({
    [boolean]: true,
    [description]: `The ${feature} feature checklist was completed.`,
    [location]: eventLocations.implementationChecklistSidebar,
    [section]: `${feature} Card`,
    [text]: eventText,
  });
};

const triggerDropDownItemSelected = (payload = {}) => {
  EventManager.triggerEvent(events.dropDownItemSelected, payload);
};

const triggerInputEntered = (payload = {}) => {
  EventManager.triggerEvent(events.inputEntered, payload);
};

const triggerIconClicked = (payload = {}) => {
  EventManager.triggerEvent(events.iconClicked, payload);
};

const triggerLinkClicked = (payload = {}) => {
  EventManager.triggerEvent(events.linkClicked, payload);
};

const triggerToggleClicked = (payload = {}) => {
  EventManager.triggerEvent(events.toggleClicked, payload);
};

const triggerModalViewed = (payload = {}) => {
  EventManager.triggerEvent(events.modalViewed, payload);
};

const triggerNudgeViewed = (payload = {}) => {
  EventManager.triggerEvent(events.nudgeViewed, payload);
};

const triggerPageViewed = (payload = {}) => {
  EventManager.triggerEvent(events.pageViewed, payload);
};

const triggerTabClicked = (payload = {}) => {
  EventManager.triggerEvent(events.tabClicked, payload);
};

export default {
  triggerActivityLogColumnsChanged,
  triggerActivityLogDateRangeChanged,
  triggerActivityLogExported,
  triggerActivityLogFilterChanged,
  triggerActivityLogFilterOptionsLoaded,
  triggerActivityLogFilterTemplateSelected,
  triggerActivityLogTableCellValueClicked,
  triggerAddMTPAdminPageOpened,
  triggerAddNewAdminButtonClicked,
  triggerAddNewDeviceButtonClicked,
  triggerAddNewDirectoryTypeSelected,
  triggerAddNewLdapButtonClicked,
  triggerAddNewUserButtonClicked,
  triggerAddNewUserFromCSVButtonClicked,
  triggerAddPolicyGroupFromTemplateClicked,
  triggerAddResourceDropDownItemClicked,
  triggerAddUserToUserGroupButtonClicked,
  triggerAddUsersFromGSuiteButtonClicked,
  triggerAddUsersFromO365ButtonClicked,
  triggerAdminDropdownButtonClicked,
  triggerAdminResendEmail,
  triggerAdminSaved,
  triggerAdminStatusChange,
  triggerAdministratorsModalClosed,
  triggerApplicationAdded,
  triggerApplicationBannerCheckItOutButtonClicked,
  triggerApplicationBannerLearnMoreButtonClicked,
  triggerAsideViewed,
  triggerAuthorizeSyncClicked,
  triggerBannerLinkClicked,
  triggerBulkImportUsersInitiated,
  triggerButtonClicked,
  triggerCalendlyLinkClicked,
  triggerChatPopoverCtaClicked,
  triggerChatPopoverDismissed,
  triggerCheckboxClicked,
  triggerCollapsableSectionButtonClicked,
  triggerCollapsableSectionControlEvent,
  triggerCollapsableSectionLinkClicked,
  triggerCommandAdded,
  triggerCommandTemplatesClicked,
  triggerConnectUserToDeviceButtonClicked,
  triggerContactSalesButtonClicked,
  triggerContinueWithMobileLinkClicked,
  triggerCopyWellClicked,
  triggerCreateNewAdminModalCanceled,
  triggerDeactivateSyncClicked,
  triggerDeactivateSyncConfirmed,
  triggerDeviceMacPolicies,
  triggerDirectoryAdded,
  triggerDirectoryImportUsersLinkClicked,
  triggerDropDownItemSelected,
  triggerEditAdminInformation,
  triggerEmailSalesLinkClicked,
  triggerEnterCreditCardButtonClicked,
  triggerFaqClicked,
  triggerGettingStartedHowItWorksModalDismissed,
  triggerGettingStartedHowItWorksModalViewed,
  triggerGettingStartedLdapProtipLearnMoreClicked,
  triggerGroupAdded,
  triggerGroupsGettingStartedModalDismissed,
  triggerGroupsGettingStartedModalViewed,
  triggerHomePageLinkClicked,
  triggerHomePageManageHomeLinkClicked,
  triggerHomePageManageToggleClicked,
  triggerHomeWidgetActionButtonClicked,
  triggerHomeWidgetHideClicked,
  triggerHomeWidgetIndividualItemClicked,
  triggerIconClicked,
  triggerImplementationChecklistComplete,
  triggerImplementationChecklistFeatureComplete,
  triggerImportUsersComplete,
  triggerInputEntered,
  triggerInsightsPaywallEmailClicked,
  triggerInsightsPaywallPricingClicked,
  triggerInsightsPaywallViewed,
  triggerInsightsVideoPlayed,
  triggerItemTableExported,
  triggerLdapAdded,
  triggerLegacyPageRedirect,
  triggerLegacyRouterPathVisited,
  triggerLinkClicked,
  triggerLocalUserAccountModalClicked,
  triggerLogOutClicked,
  triggerMdmButtonClicked,
  triggerMdmChecklistItemClicked,
  triggerMdmHomeVideoPlayed,
  triggerMembershipSuggestionsButtonClicked,
  triggerMembershipSuggestionsLinkClicked,
  triggerMembershipSuggestionsModalClosed,
  triggerModalFooterKbLinkClicked,
  triggerModalViewed,
  triggerNavItemClicked,
  triggerNavMenuItemClicked,
  triggerNavPanelCollapsed,
  triggerNewMTPAdminAdded,
  triggerNotOptimizedForMobileModalViewed,
  triggerNudgeViewed,
  triggerOutReachLinkClicked,
  triggerPageViewed,
  triggerPaymentChatLinkClicked,
  triggerPaymentInfoSubmitted,
  triggerPaymentLinkClicked,
  triggerPolicyAdded,
  triggerPolicySaveAsTemplateClicked,
  triggerSaveTemplateAsPolicyGroupClicked,
  triggerPricingButtonClicked,
  triggerProductTourLaunchButtonClicked,
  triggerProgressDotsClicked,
  triggerProviderCalendlyLinkClicked,
  triggerProviderOutreachLinkClicked,
  triggerProviderPaymentInfoSubmitted,
  triggerProviderPaymentLinkClicked,
  triggerProviderPaymentModalDismissed,
  triggerProviderPaymentModalViewed,
  triggerRadiusAdded,
  triggerRadiusGettingStartedLearnMoreClicked,
  triggerRadiusGettingStartedNewServerSaved,
  triggerReactivateSyncClicked,
  triggerRecommendedCommandClicked,
  triggerReportExported,
  triggerReportTypeVisited,
  triggerResourceAdded,
  triggerResourcesWhatsNewReadMoreLinkClicked,
  triggerSignupQuestionAnswered,
  triggerSignupQuestionConfirmationModalClicked,
  triggerSoftwareAppAdded,
  triggerSubmitIdea,
  triggerSystemAcknowledged,
  triggerSystemBound,
  triggerSystemCompatibilityLearnMoreClicked,
  triggerSystemDownloadAgentLogClicked,
  triggerSystemGetAgentLogClicked,
  triggerSystemGroupAdded,
  triggerSystemInsightsView,
  triggerSystemSupportLinkClicked,
  triggerSystemTabClicked,
  triggerSystemsDownloadAgentButtonClicked,
  triggerTabClicked,
  triggerToggleClicked,
  triggerUserAdded,
  triggerUserGroupAdded,
  triggerUserPortalSystemAgentInstall,
  triggerVideoModalLinkClicked,
  triggerWaysToAddDeviceLearnMoreClicked,
  triggerWaysToAddSystemUserLearnMoreClicked,
  triggerWelcomeModalDismissed,
  triggerWelcomeModalVideoPlayed,
  triggerWhatsNewClosed,
  triggerWhatsNewOpened,
  triggerWidgetClicked,
};
